import React from 'react';
// import PropTypes from 'prop-types';
import useLanguage from '../../../../hooks/useLanguage';
import Arrow from '../../../../svg/arr_right_top.svg';
import Star from '../../../../svg/star_non_shadow.svg';

const SubmitButton = () => {
  const langToggle = useLanguage;
  return (
    <div className="form-button__wrapper form-animate">
      <button className="form-button" type="submit">
        <span className="form-button__icon">
          <Star className="form-button__icon-star" />
          <Arrow className="form-button__icon-arrow" />
        </span>
        <span className="form-button__title-wrapper">
          <span className="form-button__title">
            {langToggle('Замовити урок', 'Заказать урок')}
          </span>
        </span>
      </button>
    </div>
  );
};

// SubmitButton.propTypes = {};

export default SubmitButton;
